// extracted by mini-css-extract-plugin
export default {"heart":"Footer_heart__2sChU","year":"Footer_year__uYItA","logo":"Footer_logo__JtwG2","merkal":"Footer_merkal__Bb2Wi","tmdb":"Footer_tmdb__bQBZT"};